import { render } from "./Rules.vue?vue&type=template&id=c72bb2b2&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=c72bb2b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c72bb2b2"

export default script